import { post, del } from '@api/request';
import axios from 'axios';

//fetchGeoRoutes is not being used
export async function fetchGeoRoutes(payload) {
  const { body } = await post(
    undefined,
    'https://us-central1-dray-app.cloudfunctions.net/entry_http',
    payload,
  );

  return body;
}

export const createSearchJob = async (
  baseUrl,
  authenticationToken,
  { payload },
) => {
  const url = `${baseUrl}/searches/`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const deleteSearchJob = async (
  baseUrl,
  authenticationToken,
  { searchID },
) => {
  const url = `${baseUrl}/searches/${searchID}`;
  const { body } = await del(authenticationToken, url);
  return body;
};

export function fetchTolls(payload) {
  return axios.post(
    'https://tolls-api.run.parade.ai',
    payload,
  );
}

export async function fetchLoadReview(params) {
  const { data } = await axios.get(
    `https://us-central1-dray-app.cloudfunctions.net/load_review?company_id=${params}`,
  );

  return data;
}

export const getDefaultRPM = payload => {
  return axios.post(
    'https://us-central1-dray-app.cloudfunctions.net/predict_rate',
    payload,
  );
};
